module.exports = __webpack_public_path__ + "static/media/walletConnectIcon.8215855c.svg";